import { IApiResponse } from "../../../@types/api-response.type";
import { IGrid } from "../../../@types/grid.type";
import { IKeyValue } from "../../../@types/key-value.type";
import { IProjectFilter, IProjectFilterForGrid } from "../../../@types/project/project-filter.type";
import { IProjectDownload, IProjectGridItem } from "../../../@types/project/project-grid-item.type";
import { IProjectPortfolioFilter } from "../../../@types/project/project-portfolio-filter.type";
import { IProjectPortfolioResponse } from "../../../@types/project/project-portfolio-response.type";
import { IProjectPorfolioStatusUpdate } from "../../../@types/project/project-portfolio-status-update.type";
import { IProjectType } from "../../../@types/project/project.type";
import { IReportMetricsBody } from "../../../@types/reports-metrics.type";
import { downloadExcel } from "../../../utils/download";
import { getErrorMessage } from "../../../utils/utils";
import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";

export const getAllClients = async () : Promise<IApiResponse<IKeyValue[]> | ApiException> => {
  try {
      const { data } = await Api.get<IApiResponse<IKeyValue[]>>(`/api/Customer/GetAllCustomers`)
      return data
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Clients'))
  }
  
}


export const getAllProjects = async ( skip: number, take: number) : Promise<IApiResponse<IGrid<IProjectType>> | ApiException> => {
  try {
      const { data } = await Api.get<IApiResponse<IGrid<IProjectType>>>(`/api/Project/GetAllProjects?skip=${skip}&take=${take}`)
      return data
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
  }
  
}

export const searchProjects = async (projectFilter: IProjectFilter) : Promise<IGrid<IProjectGridItem> | ApiException>=> {
  try {
      const response = await Api.post<IApiResponse<IGrid<IProjectGridItem>>>(`api/Project/SearchProjects`, projectFilter)
      return response.data.result
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar todos os Projetos'))
  }
}

export const searchProjectsForGrid = async (projectFilter: IProjectFilterForGrid) => {
  try {
    const { data } = await Api.post<IApiResponse<IGrid<IProjectGridItem>>>(`api/Project/SearchProjectsForGrid`, projectFilter)

    return data.result
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar todos os Projetos'))
  }
}

export const getAllProjectsIdsAndNames = async () : Promise<IKeyValue[] | ApiException> => {
  try {
      const response = await Api.get<IApiResponse<IKeyValue[]>>(`/api/Project/GetAllProjectsIdsAndNames`)
      return response.data.result;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
  }
  
}

export const getAllProjectsByCreatedUserIdAndManagerId = async (createdByUserId?: string, managerId?: string) : Promise<IKeyValue[] | ApiException> => {
  try {
      const response = await Api.get<IApiResponse<IKeyValue[]>>(`/api/Project/GetAllProjectsByCreatedUserIdAndManagerId?createdByUsedId=${createdByUserId}&managerId=${managerId}`)
      return response.data.result;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
  } 
}

export const getAllProjectsAndPositionByResourceId = async (resourceId: string) => {
  try {
      const response = await Api.get(`/api/Project/GetAllProjectsAndPositionByResourceId?resourceId=${resourceId}`)
      return response.data.result;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projetos'))
  }
  
}

export const getProjectById = async (id: string) => {
  try {
      const { data } = await Api.get(`/api/Project/GetProjectById?id=${id}`)
      return data
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar o Projeto'))
  }
  
}


export const createProject = async (projectDto: IProjectType) => { 
  try {
      const data  = await Api.post(`/api/Project/AddOrUpdateProject`, projectDto)
      return data.data
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao criar o Projeto'))
  }
}


export const deleteProject =  async (projectId: string) => {
  try {
      const { data } = await Api.delete(`/api/Project/DeleteProject/${projectId}`)
      return data
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao excluir o Projeto'))
  }
}

export const getProjectsMetrics = async (project: IReportMetricsBody) => {
  try {
      const { data } = await Api.post("/api/Project/GetProjectsMetrics",
      {"id": project.id, "startTime": project.startTime, 
      "endTime": project.endTime, "timeType": project.timeType});
      return data;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao consultar metricas do Projeto'))
  } 
}

export const getProjectsMetricsByResourceId = async (project: IReportMetricsBody) => {
  try {
      const { data } = await Api.post("/api/Project/GetProjectsMetricsByResourceId",
      {"id": project.id, "startTime": project.startTime, 
      "endTime": project.endTime, "timeType": project.timeType});
      return data;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao consultar metricas do Projeto por Colaborador'))
  } 
}

export const getProjectsMetricsByAreaId = async (project: IReportMetricsBody) => {
  try {
      const { data } = await Api.post("/api/Project/GetProjectsMetricsByAreaId",
      {"id": project.id, "startTime": project.startTime, 
      "endTime": project.endTime, "timeType": project.timeType});
      return data;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao consultar metricas do Projeto por Area'))
  } 
}

export const getProjectsMetricsByCustomerId = async (project: IReportMetricsBody) => {
  try {
      const { data } = await Api.post("/api/Project/GetProjectsMetricsByCustomerId",
      {"id": project.id, "startTime": project.startTime, 
      "endTime": project.endTime, "timeType": project.timeType});
      return data;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao consultar metricas do Projeto por Cliente'))
  } 
}

export const getProjectsMetricsByCostCenterId = async (project: IReportMetricsBody) => {
  try {
      const { data } = await Api.post("/api/Project/GetProjectsMetricsByCostCenterId",
      {"id": project.id, "startTime": project.startTime, 
      "endTime": project.endTime, "timeType": project.timeType});
      return data;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao consultar metricas do Projeto por Centro de Custo'))
  } 
}

export const getSearchProjects = async (project: IProjectGridItem) => {

  try {
      const { data } = await Api.post("/api/Project/SearchProjects",
      { 
        "name": project.projectName,
        "customerIds": project.customerIds, 
        "costCenterId": project.costCenterIds,
        "take": project.take,
        "skip": project.skip,
      });
      return data.result;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao consultar metricas do Projeto'))
  } 
}

export const GetAllProjects = async (take:number, skip:number) => {
  try {
      const { data } = await Api.get(`/api/Project/GetAllProjects?take=${take}&skip=${skip}`);
      return data.result;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao consultar metricas do Projeto'))
  } 
}

export const searchProjectsToProjectPortfolio = async (projectFilter: IProjectPortfolioFilter) : Promise<IProjectPortfolioResponse[] | ApiException>=> {
  try {
      const response = await Api.post<IApiResponse<IProjectPortfolioResponse[]>>(`api/Project/SearchProjectsToProjectPortfolio`, projectFilter)
      return response.data.result
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar todos os Projetos'))
  }
}

export const updateProjectPortifolioStatus = async (project: IProjectPorfolioStatusUpdate) : Promise<void | ApiException>=> {
  try {
      await Api.put<void>(`api/Project/UpdateProjectPortifolioStatus`, project);
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao atualizar o status do Projeto'))
  }
}

export const getProjectManagersIdsAndNames = async () : Promise<IKeyValue[]> => {
  try {
      const { data } = await Api.get<IApiResponse<IKeyValue[]>>(`/api/Project/GetProjectManagersIdsAndNames`)
      return data.result
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao consultar ids e nomes dos Responsáveis'))
  }  
}

export const DownloadProjectsToExcel = async (filters: IProjectDownload) : Promise<void> => {
  try {
      const response = await Api.post(
          `/api/Project/DownloadProjectsToExcel`, 
          filters  , { responseType: "blob" });

      downloadExcel("Projetos", response.data);
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
  }    
}

export const downloadProjectsReportToExcel = async (filters: IReportMetricsBody) : Promise<void> => {
  try {
      const response = await Api.post(
          `/api/Project/DownloadProjectsReportToExcel`, 
          filters  , { responseType: "blob" });

      downloadExcel("Relatorio-Projetos", response.data);
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
  }    
}